var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useLazyQuery } from '@apollo/client';
import { useAlert } from 'components/alert/AlertStack';
import { classNames, useEffect } from 'libs/react';
import { useDebounce } from 'libs/react';
import { useIdent } from 'libs/react';
import { useIf } from 'libs/react';
import { useMutation } from 'libs/react';
import { useState } from 'libs/react';
import { useWatch } from 'libs/react';
import { FormFieldInfos } from 'components/form/FormFieldInfos';
import { FormFieldLabel } from 'components/form/FormFieldLabel';
import { FormInput } from 'components/form/FormInput';
import { TextInput } from 'components/form/private/inputs/TextInput';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { Case } from 'components/util/Case';
import { Else } from 'components/util/Else';
import { When } from 'components/util/When';
import { CreateClientMutation } from 'graphql/Client/mutations/CreateClientMutation';
import { React } from 'libs/react';
import { ClientListQuery } from 'graphql/Client/queries/ClientListQuery';
import './FormClientSearch.scss';
/**
 * @component FormClientSearch
 * @since 1.0.0
 */
export function FormClientSearch(props) {
    const { defaultValue, name, type, style, label, tooltip, infos, scale, required, optional, disabled, placeholder, autoselect, autocorrect, isEndClient } = Object.assign({ type: 'text', name: '', style: 'normal' }, props);
    const alert = useAlert();
    const [search, setSearch] = useState('');
    const [results, setResults] = useState([]);
    const [mutate, { data: mutationData, loading: mutationLoading, error: mutationError }] = useMutation(CreateClientMutation);
    const [getResults, { loading, error, data }] = useLazyQuery(ClientListQuery, {
        variables: {
            input: {
                search,
                limit: 5,
                isEndClient: isEndClient
            }
        }
    });
    const [ident] = useIdent('form-input');
    const [valueLabel, setValueLabel] = useState('');
    const [value, setValue] = useState();
    const [focused, setFocused] = useState(false);
    const onSearchDebounced = useDebounce(getResults, 500);
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        setFocused(false);
    }
    /**
     * @function onFocus
     * @since 1.0.0
     * @hidden
     */
    function onFocus() {
        setFocused(true);
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onSearchChange(value) {
        setSearch(value);
    }
    /**
     * @function updateValue
     * @since 1.0.0
     * @hidden
     */
    function updateValue(entity) {
        setSearch('');
        setValue(entity);
        setValueLabel(entity.name);
    }
    /**
     * @function onSearchEntityClose
     * @since 1.0.0
     * @hidden
     */
    function onSearchEntityClose() {
        setValue(null);
        setValueLabel('');
    }
    /**
     * @function onAddItemClick
     * @since 1.0.0
     * @hidden
     */
    function onAddItemClick() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield mutate({
                    variables: {
                        input: {
                            name: search,
                            isEndClient: isEndClient ? isEndClient : true
                        }
                    },
                    refetchQueries: [
                        {
                            query: ClientListQuery
                        }
                    ],
                    update(cache) {
                        cache.evict({ fieldName: 'clients' });
                    }
                });
                if ((_a = result.data) === null || _a === void 0 ? void 0 : _a.createClient) {
                    updateValue(result.data.createClient);
                    if (props.onAdd) {
                        props.onAdd(result.data.createClient);
                    }
                    alert.present({
                        title: (React.createElement("p", null,
                            isEndClient ? t('Client') : t('Partner'),
                            ' ',
                            React.createElement("strong", null, result.data.createClient.name),
                            ' ',
                            t('has been created.')))
                    });
                }
            }
            catch (error) {
                alert.present({ error });
                return;
            }
        });
    }
    useIf(focused, props.onFocus, props.onBlur);
    useEffect(() => {
        if (defaultValue) {
            updateValue(defaultValue);
        }
    }, [defaultValue]);
    useWatch(() => {
        onSearchDebounced(search);
    }, [search]);
    useWatch(() => {
        if (data === null || data === void 0 ? void 0 : data.clients) {
            setResults(data.clients.items);
        }
    }, [data]);
    const className = classNames('form-client-search', 'form-client-search--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "form-client-search-field" },
            React.createElement("div", { className: "form-client-search-head" },
                label && (React.createElement(FormFieldLabel, { className: "form-input-label", style: style, label: label, ident: ident, tooltip: tooltip, required: required, optional: optional, disabled: disabled })),
                infos && (React.createElement(FormFieldInfos, { className: "form-input-infos", style: style, infos: infos }))),
            React.createElement("div", { className: "form-client-search-body" },
                React.createElement(When, null,
                    React.createElement(Case, { is: value },
                        React.createElement("div", { className: "form-client-search-value" },
                            React.createElement(TextInput, { name: name, type: type, ident: ident, value: valueLabel, scale: scale, required: required, disabled: disabled, placeholder: placeholder, autoselect: autoselect, autocorrect: autocorrect, onBlur: onBlur, onFocus: onFocus, onChange: onSearchChange }),
                            React.createElement(FormInput, { type: "hidden", value: value === null || value === void 0 ? void 0 : value.id, name: "client" }),
                            React.createElement("div", { className: "form-client-search-close", onClick: () => onSearchEntityClose() },
                                React.createElement(Icon, { value: "times" })))),
                    React.createElement(Else, null,
                        React.createElement("div", { className: "form-client-search-input" },
                            React.createElement(TextInput, { name: name, type: type, ident: ident, value: search, scale: scale, required: required, disabled: disabled, placeholder: placeholder, autoselect: autoselect, autocorrect: autocorrect, onBlur: onBlur, onFocus: onFocus, onChange: onSearchChange }),
                            React.createElement(Icon, { className: "form-input-picto", value: "search" }))))),
            search && (React.createElement("div", { className: "form-client-search-results" },
                React.createElement(When, null,
                    React.createElement(Case, { is: results.length > 0 }, results.map((client) => (React.createElement("div", { key: client.id, className: "form-client-search-result form-entity-search-result__entity", onClick: () => updateValue(client) },
                        React.createElement("div", null,
                            React.createElement("div", { className: "form-client-search-result-content" },
                                React.createElement("div", null, client.name)),
                            React.createElement("div", { className: "form-client-search-result-content-location" },
                                React.createElement("div", null, client.primaryLocation &&
                                    `(${client.primaryLocation.address +
                                        ', ' +
                                        client.primaryLocation.city})`))),
                        React.createElement(Icon, { className: "form-client-search-picto", value: "arrow-right" }))))),
                    React.createElement(Case, { is: results.length == 0 && search },
                        React.createElement("div", { className: "form-client-search-result form-client-search-result__empty" }, t('No results found')))),
                React.createElement("div", { className: "form-client-search-result form-client-search-result__add", onClick: () => onAddItemClick() },
                    React.createElement(Icon, { value: "plus" }),
                    React.createElement(Text, { value: t('Add') +
                            ` "${search}" ` +
                            `${isEndClient ? t('as new Client') : t('as new Partner')}` })))))));
}
